const books = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book1.png"),
  },
  {
    // title: ["Before the coffee", "gets cold"],

    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book2.png"),
  },
  {
    // title: ["We Solver Murders", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book3.png"),
  },
  {
    // title: ["Yellowface", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book4.png"),
  },

  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book1.png"),
  },
  {
    // title: ["Before the coffee", "gets cold"],

    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book2.png"),
  },
  {
    // title: ["We Solver Murders", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book3.png"),
  },
  {
    // title: ["Yellowface", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book4.png"),
  },

  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book1.png"),
  },
  {
    // title: ["Before the coffee", "gets cold"],

    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book2.png"),
  },
  {
    // title: ["We Solver Murders", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book3.png"),
  },
  {
    // title: ["Yellowface", ""],
    title: ["Normal People", ""],

    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    language: "Deutsch",
    sort: "Ascending",

    image: require("../pages/image/book4.png"),
  },
];
export default books;
